import { ShapeType } from '@/services/shape';
import { WatchfaceWidget, WidgetService } from '@/services/widget.service';
import { useImagesStore } from '@/store/use-images-store';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { EventType } from '@/utils/emitter.utils';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useEmitterListener, useShapeManage } from '.';
import { getImageSize } from '@/utils/fs/image.utils';

export const useWatchfaceWidget = () => {
  const { addShape } = useShapeManage();
  const watchfaceStore = useWatchfaceStore();
  const imageStore = useImagesStore();
  const resetWidgetFlex = (layer: StoreLayerItem) => {
    if (layer.type != ShapeType.Widget) return;
    if (!layer.attrs['alignItems'] && layer.attrs['alignContent']) {
      layer.attrs['alignItems'] = layer.attrs['alignContent'];
      delete layer.attrs['alignContent'];
    }
  };
  const _addWidgetTemplate = async (widgetZip: string) => {
    const service = new WidgetService();
    const widgetFile = await service.downloadZip(widgetZip);
    if (!widgetFile) return;
    const { widget, resources = [] } =
      (await service.getWidgetData(widgetFile)) ?? {};
    if (!widget || !widget.type) return;

    // 先添加资源
    for (const item of resources) {
      const { base64, basename } = item;
      const { width = 0, height = 0 } =
        (await getImageSize(undefined, base64)) ?? {};
      imageStore.insertImage({
        basename,
        value: base64,
        realpath: '',
        width,
        height
      });
    }

    resetWidgetFlex(widget);

    // 添加widget图层
    await addShape(widget.type as ShapeType, {
      cloneFrom: widget,
      attrs: {
        name: widget.attrs.name
      }
    });
  };

  /**下载序列帧资源 */
  const downLoadFramesImageArray = async (zip: string) => {
    const service = new WidgetService();
    const widgetFile = await service.downloadZip(zip);

    if (!widgetFile) return;
    const { resources = [], widget } =
      (await service.getWidgetData(widgetFile)) ?? {};
    const _sequenceFramesImageArray: string[] = [];
    const _basenameArr: string[] =
      widget?.attrs.resources?.images?.COLOR_ID ?? [];
    /**序列帧排序 */
    type Resource = { basename: string; base64: string };
    resources.sort(
      (a: Resource, b: Resource) =>
        _basenameArr.indexOf(a.basename) - _basenameArr.indexOf(b.basename)
    );
    resources.forEach((item) => {
      _sequenceFramesImageArray.push(item.base64);
    });
    return _sequenceFramesImageArray;
  };

  const _watchfaceWidgets = ref<WatchfaceWidget[]>([]);

  const watchfaceWidgets = computed(() => {
    const deviceType = watchfaceStore.deviceType ?? '';
    return _watchfaceWidgets.value.filter((item) => {
      return item.includeDeviceTypes?.includes(deviceType);
    });
  });
  const catedWatchfaceWidgets = computed(() => {
    const res: Record<string, WatchfaceWidget[]> = {};
    watchfaceWidgets.value.forEach((item) => {
      if (!res[item.cate]) {
        res[item.cate] = [];
      }
      res[item.cate].push(item);
    });
    return res;
  });

  const initWidgets = async () => {
    const service = new WidgetService();
    _watchfaceWidgets.value = (await service.getWidgets()) ?? [];

    if (downloadId.value) window.cancelIdleCallback(downloadId.value);
    downloadId.value = window.requestIdleCallback(
      () => {
        _watchfaceWidgets.value.forEach((item) => {
          service.downloadZip(item.zip);
        });
      },
      { timeout: 1000 }
    );
  };
  const downloadId = ref(0);
  onMounted(initWidgets);
  useEmitterListener([EventType['window:foucs']], initWidgets);
  onBeforeUnmount(() => {
    if (downloadId.value) window.cancelIdleCallback(downloadId.value);
  });

  return {
    watchfaceWidgets,
    catedWatchfaceWidgets,
    _addWidgetTemplate,
    downLoadFramesImageArray
  };
};
